import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../ui/Icon/Icon';
import Section from '../../ui/Section/Section';
import ProjectVisual from '../ProjectVisual/ProjectVisual';
import type { Project } from '../../../data/projects';
import { useProjectCopy } from '../../../hooks/useProjectCopy';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './NextProject.module.css';

export default function NextProject({ project }: { project: Project }) {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const copy = useProjectCopy()(project.slug);

    return (
        <Section theme="dark" shape="sheet" labelledBy="next-project-title">
            <div className="page-inner">
                <Link to={localizedPath(`/work/${project.slug}`)} className={styles.link}>
                    <span className={styles.label}>{t('project.next')}</span>
                    <span className={styles.heading}>
                        <span id="next-project-title" className={styles.name}>{project.name}</span>
                        <span className={styles.arrow} aria-hidden="true">
                            <Icon name="arrowRight" />
                        </span>
                    </span>
                    <span className={styles.category}>{copy.category}</span>
                    <span className={styles.visual}>
                        <ProjectVisual project={project} format="wide" screenAlt={copy.screenAlt} />
                    </span>
                </Link>
            </div>
        </Section>
    );
}
